import script from "./InspectFile.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectFile.vue?vue&type=script&setup=true&lang=js"

import "./InspectFile.vue?vue&type=style&index=0&id=5cdc9c12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cdc9c12"]])

export default __exports__